var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cognito',{attrs:{"type":"confirmSignUp"}},[_c('h2',[_vm._v("Confirmar conta")]),(_vm.user)?_c('div',[_c('ChangePassword',{attrs:{"user":_vm.user},on:{"passwordChanged":_vm.apply}})],1):_c('div',[_vm._v("Confirmando sua conta")])])}
var staticRenderFns = []

export { render, staticRenderFns }